export enum CustomFieldDisplayTypeEnum {
  TextboxSingleline = 'Textbox - Singleline',
  TextboxMultiline = 'Textbox - Multiline',
  DropDownList = 'Drop Down List',
}
